const APIHelper = {
    prepareFormData : (obj:any, form = new FormData(), namespace = ''):FormData => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const formKey = namespace ? `${namespace}[${key}]` : key;
  
        if (obj[key] instanceof Date) {
          // Convert Date objects to ISO strings
          form.append(formKey, obj[key].toISOString());
        } else if (obj[key] instanceof File || obj[key] instanceof Blob) {
          // Directly append File or Blob objects
          form.append(formKey, obj[key]);
        } else if (Array.isArray(obj[key])) {
          // Append arrays
          obj[key].forEach((value : any, index : number) => {
            const arrayKey = `${formKey}[${index}]`;
            if (value instanceof Object && !(value instanceof File || value instanceof Blob)) {
                APIHelper.prepareFormData(value, form, arrayKey); // Recursively handle nested objects/arrays
            } else {
              form.append(arrayKey, value);
            }
          });
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          // Recursively handle nested objects
          APIHelper.prepareFormData(obj[key], form, formKey);
        } else {
          // Append simple values (strings, numbers, etc.)
          form.append(formKey, obj[key]);
        }
      }
    }
    return form;
  }
}
export default APIHelper
  